export default "__VITE_PUBLIC_ASSET__b355fdb7__"